export default __webpack_public_path__ + "static/media/empty-catalog.0edaad47.svg";